/* Diagnose af "siden kan ikke scrolles" på mobil.
   Inaktiv som standard. Aktiveres ved at lægge ?scrolldebug=1 i URL'en, fx
   https://www.skmt.dk/?scrolldebug=1
   Viser en lille sort boks nederst, der opdaterer sig selv og fortæller hvad
   der i praksis blokerer scroll i det øjeblik det sker. */
(function () {
  if (window.location.search.indexOf('scrolldebug') === -1) return;

  var box = document.createElement('div');
  box.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;' +
    'background:rgba(0,0,0,.88);color:#0f0;font:11px/1.45 monospace;padding:6px 8px;' +
    'white-space:pre-wrap;max-height:42vh;overflow:auto;pointer-events:none';
  document.addEventListener('DOMContentLoaded', function () {
    document.body.appendChild(box);
  });

  function name(el) {
    if (!el) return 'null';
    var c = (el.className || '').toString().trim();
    return el.tagName.toLowerCase() + (c ? '.' + c.split(/\s+/).slice(0, 3).join('.') : '');
  }

  var lastTouch = '-';
  var blocked = 0;
  document.addEventListener('touchstart', function (e) {
    lastTouch = name(e.target);
  }, { passive: true });

  // Hvem aendrer html/body, og hvornaar? Noteres med tidspunkt, saa det kan ses
  // om laasen falder paa plads praecis naar soegningen aabnes.
  var aendringer = [];
  var t0 = Date.now();
  function watch(el, label) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var v = m.attributeName === 'style'
          ? (el.getAttribute('style') || '(tom)')
          : (el.getAttribute(m.attributeName) || '(tom)');
        aendringer.push('+' + ((Date.now() - t0) / 1000).toFixed(1) + 's ' +
          label + '.' + m.attributeName + ' = ' + String(v).slice(0, 70));
        if (aendringer.length > 6) aendringer.shift();
      });
    }).observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  watch(document.documentElement, 'html');
  document.addEventListener('DOMContentLoaded', function () { watch(document.body, 'body'); });

  // taeller gestures hvor nogen har kaldt preventDefault paa touchmove
  document.addEventListener('touchmove', function (e) {
    if (e.defaultPrevented) blocked++;
  }, { passive: true });

  function report() {
    var h = document.documentElement;
    var hs = getComputedStyle(h);
    var bs = getComputedStyle(document.body);
    var cx = Math.round(h.clientWidth / 2);
    var cy = Math.round(h.clientHeight / 2);
    var mid = document.elementFromPoint(cx, cy);

    // findes der et element med touch-action:none under fingeren?
    var ta = '-';
    var cur = mid;
    while (cur && cur !== document.documentElement) {
      if (getComputedStyle(cur).touchAction === 'none') { ta = name(cur); break; }
      cur = cur.parentElement;
    }

    var lines = [
      'html: "' + h.className + '"',
      'overflow  html=' + hs.overflow + '  body=' + bs.overflow +
        '   position body=' + bs.position,
      'scrollY=' + Math.round(window.scrollY) +
        '  doc.height=' + h.scrollHeight + '  viewport=' + h.clientHeight,
      'midt paa skaermen: ' + name(mid),
      'touch-action:none i kaeden: ' + ta,
      'sidste beroering: ' + lastTouch + '   blokerede touchmove: ' + blocked
    ];

    var laast = [];
    if (hs.overflow === 'hidden' || bs.overflow === 'hidden') laast.push('overflow:hidden');
    if (h.classList.contains('lock-scroll')) laast.push('lock-scroll');
    if (h.classList.contains('js-drawer-open')) laast.push('js-drawer-open');
    if (h.classList.contains('modal-open')) laast.push('modal-open');
    if (bs.position === 'fixed') laast.push('body position:fixed');
    if (ta !== '-') laast.push('touch-action:none');
    lines.push(laast.length ? '>>> BLOKERER: ' + laast.join(', ') : '>>> intet blokerer scroll lige nu');

    if (aendringer.length) {
      lines.push('--- seneste aendringer paa html/body ---');
      lines = lines.concat(aendringer);
    }

    box.textContent = lines.join('\n');
  }

  setInterval(report, 400);
})();
